import { datadogRum } from '@datadog/browser-rum';
import { datadogLogs } from '@datadog/browser-logs';

const clientToken = 'PLACEHOLDER_DDOG_CLIENT_TOKEN';
const service = 'PLACEHOLDER_DDOG_SERVICE';
const ddogEnv = 'PLACEHOLDER_DDOG_ENV'
const ddsamplerate = parseInt('PLACEHOLDER_DDOG_SAMPLE_RATE') || 5 

export const initDatadog = () => {
	// Application ID and clientToken is sent with every RUM & logs request so it's ok that they're part of the commit history and not env variables
	datadogRum.init({
		applicationId: 'PLACEHOLDER_DDOG_RUM_APP_ID',
		clientToken: clientToken,
		site: 'datadoghq.eu',
		service: service,
		env: ddogEnv,
		sessionSampleRate: ddsamplerate,
		sessionReplaySampleRate: 5,
		startSessionReplayRecordingManually: false,
		defaultPrivacyLevel: 'mask-user-input',
	});
	datadogLogs.init({
		clientToken: clientToken,
		site: 'datadoghq.eu',
		forwardErrorsToLogs: true,
		sessionSampleRate: 100,
		service: service,
		env: ddogEnv,
	});
};
